<template>
  <div v-if="currentOpenFacet === this.facetnameLocal" class="sm-screen">
    <div class="sm-screen__actions sm-screen__actions_top">
      <div class="sm-screen__slot sm-screen__slot_l">
        <button @click="closeFacet" class="sm-screen__button sm-screen__button_f-small">
          <svg width="5" height="9" viewBox="0 0 5 9" xmlns="http://www.w3.org/2000/svg" class="sm-screen__icon sm-screen__icon__arrow-left">
            <use xlink:href="#f-small-back"></use>
          </svg>
          Назад
        </button>
      </div>
      <div class="sm-screen__slot">
        <span class="sm-screen__title">Категории</span>
      </div>
      <div class="sm-screen__slot sm-screen__slot_r">
        <button @click="toggleOpenFacets" class="sm-screen__button sm-screen__button_f-small">
          Закрыть
        </button>
      </div>
    </div>
    <div class="sm-screen__content">
      <div class="sm-facet_category">
        <ul>
          <li>
            <button @click="onSelectCategory(0)"
                    class="sm-facet-category"
                    :class="{'sm-facet-category_active': selected_category_id_local === 0}"
            >
              <span class="sm-facet-category__text">Во всех категориях</span>
            </button>
          </li>
          <li v-for="item in categories" :key="item.id">
            <button @click="onSelectCategory(item.id)"
                    class="sm-facet-category"
                    :disabled="item.id === selected_category_id_local"
                    :class="{'sm-facet-category_active': item.id === selected_category_id_local}"
            >
              <span class="sm-facet-category__text">{{ item.name }}</span>
              <span class="sm-facet-category__amount">{{ item.value }}</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
    <div class="sm-screen__actions sm-screen__actions_bottom">
      <button @click="submitCategory" class="sm-screen__button sm-screen__button_stretch">
        Выбрать {{ getCategoryName() }}
      </button>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
name: "facet-dialog-category",
  props: ["facetname", "selected_category_id"],
  data() {
    return {
      facetnameLocal: this.facetname,
      selected_category_id_local: this.selected_category_id
    }
  },
  computed: {
    ...mapGetters("search", ["categoryFacets", "currentOpenFacet"]),
    categories: function () {
      return this.categoryFacets;
    },
    selectedCategoryInfo: function () {
      let selected = this.selected_category_id_local;
      return this.categories.filter(function (item) {
        return item.id === selected;
      })
    }
  },
  methods: {
    ...mapActions("search", [
      "selectCategory",
      "addFilter",
      "doSearch",
      "resetFilters",
      "setCurrentOpenFacet",
      "toggleOpenFacets"
    ]),
    onSelectCategory: function (category_id) {
      this.selected_category_id_local = category_id;
    },
    submitCategory() {
      this.selectCategory(this.selected_category_id_local);

      //if(category_id === 0) {
      this.resetFilters();
      //}
      this.addFilter({category: this.selected_category_id_local});

      this.closeFacet();

      this.doSearch().then(() => { }).catch(err => { console.log(err.response.statusText) });
    },
    getCategoryName() {
      const info = this.selectedCategoryInfo;
      return (typeof info[0] !== 'undefined') ? info[0].name : '';
    },
    getCategoryValue() {
      const info = this.selectedCategoryInfo;
      return (typeof info[0] !== 'undefined') ? info[0].value : '';
    },
    closeFacet() {
      this.setCurrentOpenFacet('')
    }
  }
}
</script>